var _path, _path2, _path3, _circle;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAlbumIcon = function SvgAlbumIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4603 30H11.7778C10.7959 30 10 29.0051 10 27.7778V12.2222C10 10.9949 10.7959 10 11.7778 10H24.2222C24.7311 10 25.19 10.2672 25.5141 10.6955",
    stroke: "currentColor",
    strokeWidth: 2.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0791 13.4425L18.2223 12.6076C17.3657 12.5417 16.6065 13.3315 16.5265 14.3716L15.5126 27.5549C15.4326 28.595 16.0622 29.4916 16.9188 29.5575L27.7756 30.3925C28.6322 30.4583 29.3914 29.6685 29.4714 28.6284L30.4853 15.4451C30.5653 14.405 29.9357 13.5084 29.0791 13.4425Z",
    stroke: "currentColor",
    strokeWidth: 2.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8155 24.1669L25.7322 20.2058L15.5221 27.4442",
    stroke: "currentColor",
    strokeWidth: 2.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.8141,
    cy: 17.3206,
    r: 1.5,
    transform: "rotate(4.39771 20.8141 17.3206)",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAlbumIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "f915a9878cd5854cfd95220ca738895d.svg";